import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { checkNotificationPermission, requestNotificationPermission, requestForToken } from "./firebase";
import * as auth from "../Auth/_redux/authRedux";

function NotificationPrompt() {
  const [permissionStatus, setPermissionStatus] = useState("checking");
  const [isVisible, setIsVisible] = useState(false);
  const dispatch = useDispatch();

  const { authToken, user } = useSelector((state) => ({
    authToken: state.auth.authToken,
    user: state.auth.user,
  }));

  useEffect(() => {
    // Controlla lo stato dei permessi
    const status = checkNotificationPermission();
    setPermissionStatus(status);

    // Mostra il prompt se i permessi non sono stati ancora richiesti
    // OPPURE se sono concessi ma manca il token (es. utente ha cancellato i dati o cambio browser)
    if (status === "default" || (status === "granted" && user && !user.fcmToken)) {
      setIsVisible(true);
    }
  }, [user]);

  const handleEnableNotifications = async () => {
    const granted = await requestNotificationPermission();

    if (granted) {
      setPermissionStatus("granted");
      setIsVisible(false);
      // Ottieni il token FCM (forzando un refresh per assicurarsi che sia valido)
      const token = await requestForToken(authToken, true);
      if (token && user) {
        // Aggiorna lo stato utente con il nuovo token
        const updatedUser = { ...user, fcmToken: token };
        dispatch(auth.actions.setUser(updatedUser));
      }
    } else {
      setPermissionStatus(checkNotificationPermission());
      setIsVisible(false);
    }
  };

  const handleDismiss = () => {
    setIsVisible(false);
  };

  // Non mostrare nulla se non supportato o non visibile
  if (permissionStatus === "not-supported" || !isVisible) {
    return null;
  }

  // Se bloccato, mostra un avviso discreto
  if (permissionStatus === "denied") {
    return (
      <div
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          backgroundColor: "#fff3cd",
          border: "1px solid #ffc107",
          borderRadius: "8px",
          padding: "15px",
          maxWidth: "350px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          zIndex: 9999,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
          <div>
            <strong>⚠️ Notifiche bloccate</strong>
            <p style={{ margin: "5px 0 0 0", fontSize: "14px" }}>
              Per ricevere le notifiche, abilitale nelle impostazioni del browser.
            </p>
          </div>
          <button
            onClick={handleDismiss}
            style={{
              border: "none",
              background: "transparent",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>
      </div>
    );
  }

  // Se default o concesso (ma senza token), mostra il pulsante per attivare
  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        right: "20px",
        backgroundColor: "#ffffff",
        border: "1px solid #dee2e6",
        borderRadius: "8px",
        padding: "15px",
        maxWidth: "350px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        zIndex: 9999,
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", marginBottom: "10px" }}>
        <strong>🔔 Attiva le notifiche</strong>
        <button
          onClick={handleDismiss}
          style={{
            border: "none",
            background: "transparent",
            fontSize: "18px",
            cursor: "pointer",
          }}
        >
          ×
        </button>
      </div>
      <p style={{ margin: "0 0 15px 0", fontSize: "14px" }}>Ricevi aggiornamenti importanti in tempo reale</p>
      <div style={{ display: "flex", gap: "10px" }}>
        <button
          onClick={handleEnableNotifications}
          style={{
            flex: 1,
            padding: "8px 16px",
            backgroundColor: "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Attiva
        </button>
        <button
          onClick={handleDismiss}
          style={{
            padding: "8px 16px",
            backgroundColor: "transparent",
            color: "#6c757d",
            border: "1px solid #dee2e6",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Non ora
        </button>
      </div>
    </div>
  );
}

export default NotificationPrompt;
